@use '~/theme/theme' as *;
@use '~/theme/typography';

.identitySelection {
  display: flex;
  gap: spacing(2);
  margin-bottom: spacing(2);
  justify-content: space-around;
  align-items: center;
  overflow: visible;
}

.modal {
  width: 600px;
}

.content {
  padding-top: spacing(2);
  padding-bottom: spacing(2);
}

.control {
  flex: 1 0 0;
}

.identityButton {
  @include typography.body2;
  @include typography.regular;
  @include border-radius(sm);

  color: color(grey-800);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: spacing(1);
  cursor: pointer;
  border: 0;
  background: none;
  min-width: spacing(8);

  &:hover {
    background: color(grey-200);
  }

  &[data-selected='true'] {
    color: color(violet-600);
  }

  &[data-focus-visible] {
    outline: 2px solid color(violet-600);
  }
}
